<template>
    <div class="register-wrapper">
        <title-bar title="注册"></title-bar>
        <div class="register-iframe">
            <iframe
                class="lanhu-register"
                marginheight="4.5rem"
                :src="`https://${domain}.com/mobile/#/register`"
                frameborder="0"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.register-wrapper {
    width: 100%;
    height: 100vh;
    .register-iframe {
        position: relative;
        bottom: 0;
        overflow: hidden;
        width: 100%;
        height: 100%;
        .lanhu-register {
            position: absolute;
            width: 100%;
            box-sizing: border-box;
            height: 100%;
            padding-top: 2.35rem;
            bottom: 0;
        }
    }
}
</style>
<script>
import titleBar from "../../components/layout/TitleBar"
export default {
    name: "register",
    components: {
        titleBar
    },
    created() {
        this.$root.eventBus.$emit("showLoading")
    },
    mounted() {
        var _this = this
        var myFrame = document.querySelector(".lanhu-register")
        myFrame.onload = function() {
            _this.$root.eventBus.$emit("hideLoading")
        }
    }
}
</script>


